/* eslint-disable import/no-cycle */
/*
 * @Descripttion:
 * @version:
 * @Author: lxh3@meitu.com
 * @Date: 2025-05-24 16:00:20
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-10-23 20:45:40
 */
import {
  StateCreator, create,
} from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import {
  AgentModel, AgentModelCategory, ModelPatternInfoItem, UsedModel,
} from '$/domains/agentModel/type';
import type { WorkflowJSON } from '@flowgram.ai/free-layout-editor';
import { INPUT_MEDIA_UPLOAD_COUNT_LIMITS } from '$/utils/mediaUploadLimits';
import { TChatState } from './types';

/** 创建旧版 Chat Store 的默认状态切片。 */
const chatSlice: StateCreator<TChatState, [
  ['zustand/immer', never],
]> = () => ({
  roomTitle: '',
  workFlowData: '',
  showDocumentUpload: false,
  showModelSelect: false,
  modelMap: {
    imageModel: {
      modelCategoryTitle: '',
      modelItems: [],
    },
    videoModel: {
      modelCategoryTitle: '',
      modelItems: [],
    },
  },
  modelPatternInfoList: [],
  activeMode: 'normal',
  showSelectMode: false,
  showAgentThinkingMode: false,
  agentThinkingModeType: '', // 默认为空不展示按钮
  agentThinkingModeList: [],
  sideBarWidth: 400,
  sideBarCollapsed: true,
  createChatStatus: 'normal',
  usedModel: {
    activeType: 'imageModel',
    imageModel: {
      modelDesc: '',
      modelName: '',
      modelValue: '',
      enable: false,
    },
    videoModel: {
      modelDesc: '',
      modelName: '',
      modelValue: '',
      enable: false,
    },
  },
  onPaySuccessContainueSSE: null,

  MAX_AGENT_IMAGE_NUMS: INPUT_MEDIA_UPLOAD_COUNT_LIMITS.maxImageNum,
  MAX_AGENT_VIDEO_NUMS: INPUT_MEDIA_UPLOAD_COUNT_LIMITS.maxVideoNum,
  MAX_AGENT_DOCUMENT_NUMS: INPUT_MEDIA_UPLOAD_COUNT_LIMITS.maxDocumentNum,
  MAX_AGENT_TEXT_NUMS: 5000,
});

const useChatStore = create<TChatState>()(
  immer(
    persist(
      chatSlice,
      {
        name: 'useChatStore',
        version: 1,
        partialize: (state) => ({ sideBarWidth: state.sideBarWidth }),
      },
    ),
  ),
);
export default useChatStore;

/**
 * 设置是否展示思考模式模式
 * @param showAgentThinkingMode 是否展示思考模式
 */
export const setShowAgentThinkingMode = (showAgentThinkingMode: boolean) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      showAgentThinkingMode,
    };
  });
};

/**
 * 设置当前模型类型
 * @param agentThinkingModeType 模型类型
 */
export const setAgentThinkingModeType = (agentThinkingModeType: string) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      agentThinkingModeType,
    };
  });
};
/**
 * 设置当前模型类型
 * @param list 模型列表
 */
export const setAgentThinkingModeList = (list: AgentModel[]) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      agentThinkingModeList: list,
    };
  });
};

/**
 * 获取当前激活模型
 * @returns 当前激活模型
 */
export const getActiveAgentThinkingMode = (): AgentModel | undefined => {
  const { agentThinkingModeType } = useChatStore.getState();
  return useChatStore.getState().agentThinkingModeList.find((item) => item.modelValue === agentThinkingModeType);
};
/**
 * 设置房间名称
 */
export const setRoomTitle = (roomTitle: string) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      roomTitle,
    };
  });
};
// 设置选中模型
export const setUsedModel = (usedModel: UsedModel) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      usedModel,
    };
  });
};

// 设置上传按钮是否展示
export const setShowDocumentUpload = (showDocumentUpload: boolean) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      showDocumentUpload,
    };
  });
};

// 设置上传按钮是否展示
export const setShowModelSelect = (showModelSelect: boolean) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      showModelSelect,
    };
  });
};

// 设置模型列表
export const setModelMap = (modelMap: { imageModel: AgentModelCategory; videoModel: AgentModelCategory; }) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      modelMap,
    };
  });
};

/**
 * 设置当前模式
 *
 * @export
 * @param {'normal' | 'high'} activeMode
 */
export function setActiveMode(activeMode: 'normal' | 'high') {
  useChatStore.setState((state) => {
    return {
      ...state,
      activeMode,
    };
  });
}

/**
 * 设置当前模式信息
 *
 * @export
 * @param {ModelPatternInfoItem[]} modelPatternInfo
 */
export function setModelPatternInfo(modelPatternInfo: ModelPatternInfoItem[]) {
  useChatStore.setState((state) => {
    return {
      ...state,
      modelPatternInfoList: modelPatternInfo,
    };
  });
}

/**
 * 设置当前模式
 *
 * @export
 * @param {'normal' | 'high'} activeMode
 */
export function setShowSelectMode(showSelectMode: boolean) {
  useChatStore.setState((state) => {
    return {
      ...state,
      showSelectMode,
    };
  });
}

// 自定义会话时图片和视频和文本的最大数量
export const chatSendLimit = ({
  maxImageNum,
  maxVideoNum,
  maxTextNum,
  maxDocumentNum,
}: {
  maxImageNum?: number;
  maxVideoNum?: number;
  maxTextNum?: number;
  maxDocumentNum?: number;

}) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      MAX_AGENT_DOCUMENT_NUMS: typeof maxDocumentNum === 'undefined'
        ? INPUT_MEDIA_UPLOAD_COUNT_LIMITS.maxDocumentNum
        : maxDocumentNum,
      MAX_AGENT_IMAGE_NUMS: typeof maxImageNum === 'undefined'
        ? INPUT_MEDIA_UPLOAD_COUNT_LIMITS.maxImageNum
        : maxImageNum,
      MAX_AGENT_VIDEO_NUMS: typeof maxVideoNum === 'undefined'
        ? INPUT_MEDIA_UPLOAD_COUNT_LIMITS.maxVideoNum
        : maxVideoNum,
      MAX_AGENT_TEXT_NUMS: typeof maxTextNum === 'undefined' ? 5000 : maxTextNum,
    };
  });
};

/**
 * 设置sidebar宽度
 * @param width 宽度
 */
export const setSideBarWidth = (width: number) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      sideBarWidth: width,
    };
  });
};

/**
 * 设置sidebar折叠状态
 * @param collapsed 折叠状态
 */
export const setSideBarCollapsed = (collapsed: boolean) => {
  useChatStore.setState((state) => {
    return {
      ...state,
      sideBarCollapsed: collapsed,
    };
  });
};

/**
 * 切换侧边栏折叠状态
 * 切换 sideBarCollapsed 为相反值
 */
export function toggleSideBarCollapsed() {
  useChatStore.setState((state) => {
    return {
      ...state,
      sideBarCollapsed: !state.sideBarCollapsed,
      // 折叠的时候会更宽度200,无需存储更新，仅在拖拽的时候更新
      // sideBarWidth: !state.sideBarCollapsed ? 400 : 200,
    };
  });
}

/**
 * 更新新建会话按钮的状态
 * @param {'normal' | 'disable'} status - 按钮状态
 */
export function updateCreateChatStatus(status: 'normal' | 'disable') {
  useChatStore.setState(() => {
    return { createChatStatus: status };
  });
}

/**
 * 设置支付成功后继续 SSE 的回调函数
 *
 * @export
 * @param {TChatState['onPaySuccessContainueSSE']} onPaySuccessContainueSSE 新的回调函数
 */
export function setOnPaySuccessContainueSSE(onPaySuccessContainueSSE: TChatState['onPaySuccessContainueSSE']) {
  useChatStore.setState((state) => {
    return {
      ...state,
      onPaySuccessContainueSSE,
    };
  });
}

/**
 * 节点流数据 用于agent发起会话上下文
 *
 * @export
 * @param {WorkflowJSON} data
 */
export function setChatWorkFlowData(data: WorkflowJSON) {
  useChatStore.setState(() => {
    return { workFlowData: JSON.stringify(data) };
  });
}
